import React, { type CSSProperties } from 'react';

const DURATION = 1.8

const spinnerStyles: Record<string, CSSProperties> = {
  rotatingContainer: {
    position: 'absolute',
    animation: `rotateSteps ${DURATION * 6}s steps(1, end) ${(DURATION * 0.33 * 0.833) + (DURATION * 0.25)}s infinite`,
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainDiv: {
    position: 'absolute' as const,
    width: '60px',
    height: '35px',
  },
  innerDiv: {
    width: '100%',
    height: '100%',
    position: 'relative' as const,
  },
  span: {
    position: 'absolute' as const,
    width: '6px',
    height: '0%',
    borderRadius: '8px',
    background: '#f4aa5e',
    zIndex: 999999,
  },

  h1: { left: 0, animation: `load ${DURATION}s ease 0s infinite` },
  h2: { left: 0, animation: `load ${DURATION}s ease ${DURATION * 0.33 * 0.167}s infinite` },
  h3: { left: 0, animation: `load ${DURATION}s ease ${DURATION * 0.33 * 0.333}s infinite` },
  h4: { left: 0, animation: `load ${DURATION}s ease ${DURATION * 0.33 * 0.5}s infinite` },
  h5: { left: 0, animation: `load ${DURATION}s ease ${DURATION * 0.33 * 0.667}s infinite` },
  h6: { left: 0, animation: `load ${DURATION}s ease ${DURATION * 0.33 * 0.833}s infinite` },
};

const keyframes = `
  @keyframes rotateSteps {
      0% { transform: rotate(0deg); }
      16.7% { transform: rotate(60deg); }
      33.3% { transform: rotate(120deg); }
      50% { transform: rotate(180deg); }
      66.7% { transform: rotate(240deg); }
      83.3% { transform: rotate(300deg); }
      100%{ transform: rotate(360deg); }
  }
  @keyframes load {
    0% { bottom: 0; height: 0; }
    10% { bottom: 0; height: 0; }
    20% { bottom: 0; height: 100%; }
    60% { top: 0; height: 100%; }
    70% { top: 0; height: 0; }
  }
`;

const Spinner = ({
  background = '#f4aa5e',
  className,
}: {
  background?: string;
  className?: string;
}): React.JSX.Element => {
  return (
    <span className={className}>
      <style>{keyframes}</style>
      <div style={spinnerStyles['rotatingContainer']}>
        <section style={spinnerStyles['container']}>
          <div style={spinnerStyles['mainDiv']}>
            <div style={spinnerStyles['innerDiv']}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h1'], background }}></span>
            </div>
          </div>
          <div style={spinnerStyles['mainDiv']}>
            <div style={{...spinnerStyles['innerDiv'], rotate: '60deg'}}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h2'], background }}></span>
            </div>
          </div>
          <div style={spinnerStyles['mainDiv']}>
            <div style={{...spinnerStyles['innerDiv'], rotate: '120deg'}}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h3'], background }}></span>
            </div>
          </div>
          <div style={spinnerStyles['mainDiv']}>
            <div style={{...spinnerStyles['innerDiv'], rotate: '180deg'}}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h4'], background }}></span>
            </div>
          </div>
          <div style={spinnerStyles['mainDiv']}>
            <div style={{...spinnerStyles['innerDiv'], rotate: '240deg'}}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h5'], background }}></span>
            </div>
          </div>
          <div style={spinnerStyles['mainDiv']}>
            <div style={{...spinnerStyles['innerDiv'], rotate: '300deg'}}>
              <span style={{ ...spinnerStyles['span'], ...spinnerStyles['h6'], background }}></span>
            </div>
          </div>
        </section>
      </div>
    </span>
  );
};

export default Spinner;
